/**
 * Milotté scroll motion — Phase 4.1 (+ høst 2026)
 *
 * Two effects:
 *   1. Fade-in as sections cross into the viewport (.js-fade-in → .in-view).
 *      Høst 2026: every top-level section inside #MainContent gets the class
 *      automatically (except the first one, so the hero renders instantly),
 *      so new sections need no markup change. The class is added by JS,
 *      never in HTML, so nothing is hidden when JS is off.
 *   2. Light parallax on hero image when [data-parallax="true"] (0.3 ratio)
 *
 * Respects prefers-reduced-motion: reduce — both effects disabled.
 */

(function () {
  'use strict';

  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  const reduceMotion =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduceMotion) {
    document.querySelectorAll('.js-fade-in').forEach(function (el) {
      el.classList.add('in-view');
    });
    return;
  }

  function tagSections() {
    const main = document.getElementById('MainContent');
    if (!main) return;
    const sections = main.querySelectorAll(':scope > .shopify-section');
    sections.forEach(function (wrapper, index) {
      if (index === 0) return;
      const target = wrapper.firstElementChild;
      if (!target) return;
      if (target.classList.contains('js-fade-in')) return;
      if (target.querySelector('.js-fade-in')) return;
      target.classList.add('js-fade-in');
    });
  }

  // ---- 1. Fade-in observer ----
  if ('IntersectionObserver' in window) {
    const fadeInObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            fadeInObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -5% 0px' }
    );

    function observeFadeTargets() {
      tagSections();
      document.querySelectorAll('.js-fade-in:not(.in-view)').forEach(function (el) {
        fadeInObserver.observe(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeFadeTargets);
    } else {
      observeFadeTargets();
    }

    // Theme editor: re-observe when sections are added or re-rendered.
    document.addEventListener('shopify:section:load', observeFadeTargets);
  } else {
    document.querySelectorAll('.js-fade-in').forEach(function (el) {
      el.classList.add('in-view');
    });
  }

  // ---- 2. Hero parallax ----
  function initParallax() {
    const heroes = document.querySelectorAll('.hero-editorial[data-parallax="true"]');
    if (!heroes.length) return;

    let ticking = false;

    function update() {
      heroes.forEach(function (hero) {
        const rect = hero.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        const media = hero.querySelector('.hero-editorial__media');
        if (!media) return;
        const offset = rect.top * -0.3;
        media.style.transform = 'translate3d(0, ' + offset.toFixed(1) + 'px, 0)';
      });
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initParallax);
  } else {
    initParallax();
  }
})();